module.exports = __webpack_public_path__ + "img/contabil.852999ce.svg";